import api from '../config/api';

export interface AnalyticsData {
  users: {
    total: number;
    active: number;
    inactive: number;
    members: number;
    admins: number;
    visitors: number;
    by_month: Array<{ month: string; label: string; count: number }>;
  };
  exposes: {
    total: number;
    this_month: number;
    by_type: {
      jeudi_matin: number;
      jeudi_soir: number;
      mercredi_soir: number;
    };
    by_status: {
      a_venir: number;
      passes: number;
    };
    total_vues: number;
    top_5: Array<{ id: number; theme: string; nombre_vues: number }>;
  };
  ramadan: {
    total: number;
    this_month: number;
    by_status: {
      a_venir: number;
      passes: number;
    };
    total_vues: number;
    top_5: Array<{ id: number; theme: string; nombre_vues: number }>;
  };
  events: {
    total: number;
    this_month: number;
    upcoming: number;
    past: number;
    total_vues: number;
    by_type: Array<{ type_event: string; count: number }>;
    top_5: Array<{ id: number; titre: string; nombre_vues: number }>;
  };
  bibliotheque: {
    marabouts: number;
    livres: number;
    sourates: number;
    livres_by_categorie: Array<{ categorie: string; count: number }>;
    livres_by_langue: Array<{ langue: string; count: number }>;
  };
  mediatheque: {
    total_audios: number;
    this_month: number;
    total_ecoutes: number;
    total_downloads: number;
    total_likes: number;
    by_categorie: Array<{ categorie: string; count: number }>;
    top_5: Array<{ id: number; titre: string; nombre_ecoutes: number }>;
  };
  galerie: {
    total: number;
    this_month: number;
    total_vues: number;
    by_categorie: Array<{ categorie: string; count: number }>;
  };
  notifications: {
    total: number;
    sent: number;
    pending: number;
    total_emails_sent: number;
    total_emails_failed: number;
    by_type: Array<{ type_notification: string; count: number }>;
  };
  contact: {
    total: number;
    this_month: number;
    lus: number;
    non_lus: number;
    repondus: number;
    non_repondus: number;
  };
  daara: {
    total: number;
    this_month: number;
    total_vues: number;
    by_jour: Array<{ jour: string; count: number }>;
  };
  creation_last_30_days: {
    users: number;
    exposes: number;
    ramadan: number;
    events: number;
    livres: number;
    audios: number;
    galerie: number;
    contacts: number;
    daara: number;
  };
}

export const analyticsService = {
  getAnalytics: async (): Promise<AnalyticsData> => {
    const response = await api.get('/analytics/');
    return response.data;
  },
};

